import React, {useState} from "react"
import { FiAtSign, FiBold, FiCode, FiItalic, FiLink, FiList, FiPaperclip,FiSmile, FiType, FiZap } from "react-icons/fi"
import clx from "classnames"
import teamStore from '../../../../stores/useTeam'
import { EmojiPicker } from "../../messsenger/content/emojipicker"

export const Send = () => {
  const {addMessage} = teamStore(state=>state)
  const [message, setMessage] = useState('');
  const [updated, setUpdated] = useState('');

  const handleChange = (event) => {
    setMessage(event.target.value);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // 👇 Get input value
      setUpdated(message);
      const object = {
          id:11,
          name:"You",
          me:true,
          avatar:"/images/avatars/Vector-12.png",
          date:"10:40 PM",
          messages:[
              message
          ],
      }

      addMessage(object, message)


    }
  };


    return (
        <React.Fragment>
              <div className="send sticky-bottom-1">
                            <div className="mb-4 mx-4 flex flex-col gap-2">
                            <div className="border border-gray-300 dark:border-zinc-700 dark:bg-zinc-900 rounded-md">
                                <textarea
                                  type="text"
                                  id="message"
                                  name="message"
                                  value={message}
                                  onChange={handleChange}
                                  onKeyDown={handleKeyDown}
                                  onInput={e=>{
                                        e.target.style.height = "1px";
                                        e.target.style.height = (e.target.scrollHeight)+"px";

                                    }}
                                    placeholder="Write message"
                                    className="auto_height p-3 border-none outline-none bg-transparent w-full"
                                    rows="1"
                                ></textarea>
                                <div className="bg-gray-100 dark:bg-zinc-900 dark:border-zinc-700 border-t border-gray-300 flex justify-between items-center p-2 px-3">
                                <FiZap size={23}
                                    className="cursor-pointer text-gray-600 h-5"
                                />
                                <FiLink size={23}
                                    className="cursor-pointer text-gray-600 h-5"
                                />
                                <FiBold size={23}
                                    className="cursor-pointer text-gray-600 h-5"
                                />
                                <FiItalic size={23}
                                    className="cursor-pointer text-gray-600 h-5"
                                />
                                <FiType size={23}
                                    className="cursor-pointer text-gray-600 h-5"
                                />
                                <FiCode size={23}
                                    className="cursor-pointer text-gray-600 h-5"
                                />
                                <FiList size={23}
                                    className="cursor-pointer text-gray-600 h-5"
                                />
                                <FiAtSign size={23}
                                    className="cursor-pointer text-gray-600 h-5"
                                />
                             
                                <EmojiPicker 
                                    emoji={ <FiSmile size={23} className="cursor-pointer text-gray-600 h-5" />}
                                    direction="right-0 bottom-8"
                               />
                             
                                <FiPaperclip size={23}
                                    className="cursor-pointer text-gray-600 h-5"
                                />
                                </div>
                            </div>
                            </div>
               </div>
        </React.Fragment>
    )
  }